import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = null;

let error_routers = {
  mode: 'hash',
  /*mode: 'history',*/
  base: process.env.BASE_URL,
  routes: [{
    path: '*',
    component: () => import('@/views/pages/Index'),
    children: [
      {
        name: portal_mode.error,
        path: '',
        props: {
          errorId: portal_mode.error, errorMsg: portal_mode.msg
        },
        component: () => import('@/views/pages/Error'),
      },
    ],
  }]
}

let portal_routers = {
  mode: 'hash',
  /*mode: 'history',*/
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/error',
      component: () => import('@/views/pages/Index'),
      props: (route) => ({ overflow: false }),
      children: [
        {
          props: { errorId: '503', errorMsg: 'SYSTEM DOWN :(' },
          name: 'System Error',
          path: 'systemDown',
          props: (route) => ({ overflow: false }),
          component: () => import('@/views/pages/Error'),
        }, {
          name: 'Error',
          path: 'custom',
          props: (route) => (Object.assign({ overflow: false }, route.query, route.params)),
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
    {
      path: '/extWidget',
      component: () => import('@/views/pages/Index'),
      props: (route) => ({ theme: "light", menu: false, fullscreen: true }),
      children: [
        {
          path: 'eventi',
          component: () => import('@/widget/listEventi'),
          props: (route) => ({ mode: "extWidget" })
        },
      ],
    },
    {
      path: '/publicDashboard',
      component: () => import('@/views/pages/Index'),
      props: (route) => ({ theme: "light", menu: false, fullscreen: true, overflow: false }),
      children: [
        {
          name: 'dashboard gara',
          path: 'dashboardGara/:idGara',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/dashboardGara'),
          props: (route) => ({ paramsIdGara: route.params.idGara ? parseInt(route.params.idGara) : null }),
        },
      ],
    },
    {
      path: '/auth',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Lock',
          path: 'lock',
          meta: { requiresAuth: true },
          component: () => import('@/views/pages/Lock'),
        },
        {
          name: 'Login',
          path: 'login/:fromUri?',
          component: () => import('@/views/pages/Login'),
          props: (route) => ({ fromUri: route.params.fromUri }),
        },
        {
          name: 'Register',
          path: 'register',
          component: () => import('@/views/pages/Register'),
        },
        {
          name: 'Reset Password',
          path: 'resetPassword/:email/:token',
          component: () => import('@/views/pages/ResetPassword'),
        }, ,
        {
          name: 'Install App',
          path: 'installApp',
          component: () => import('@/app/installApp'),
        },
      ],
    },
    {
      path: '/',
      redirect: "/portal",
      props: {
        fullscreen: true,
        theme: 'light',
      },
    },
    // Portale
    {
      path: '/portal',
      component: () => import('@/views/portal/Index'),
      children: [
        // default page
        {
          name: '',
          path: '',
          meta: { requiresAuth: true },
          redirect: { name: 'Dashboard' },
        },
        // Gestione ruolo
        {
          name: 'Edit role',
          path: 'editRole/:role',
          meta: { requiresAuth: true },
          component: () => import('@/app/admin/editRole'),
          props: (route) => ({ card: true, role: route.params.role }),
        },
        // pannello amministrativo
        {
          name: 'admin panel',
          path: 'admin',
          meta: { requiresAuth: true },
          component: () => import('@/app/adminPanel'),
        },
        // Scansiona info utente
        {
          name: 'Scan user info',
          path: 'scanUserInfo',
          meta: { requiresAuth: true },
          component: () => import('@/app/getQRInfoUser'),
        },
        // Dashboard
        {
          name: 'Dashboard',
          path: 'dashboard',
          meta: { requiresAuth: true },
          component: () => import('@/app/Dashboard'),

        },
        // Help
        {
          name: 'Guida',
          path: 'Guida',
          meta: { requiresAuth: true },
          component: () => import('@/app/help'),

        },
        {
          name: 'list order',
          path: 'listOrder/:mode?',
          meta: { requiresAuth: true },
          component: () => import('@/widget/listOrdini'),
          props: (route) => ({ mode: route.params.mode }),
        },
        {
          name: 'view order',
          path: 'viewOrder/:orderId',
          meta: { requiresAuth: true },
          component: () => import('@/widget/viewOrder'),
          props: (route) => ({ orderId: route.params.orderId }),
        },
        {
          name: 'Anagrafica Utenti',
          path: 'anagraficaUtenti',
          meta: { requiresAuth: true },
          component: () => import('@/app/anagraficaUtenti'),
        },
        {
          name: 'Profile page',
          path: 'profile/:masterId?',
          meta: { requiresAuth: true },
          component: () => import('@/app/UserProfile'),
          props: (route) => ({ paramsType: "plain", paramsMasterId: route.params.masterId ? parseInt(route.params.masterId) : null }),

        },
        {
          name: 'Send notify & message',
          path: 'notify/send',
          meta: { requiresAuth: true },
          component: () => import('@/app/notify/send'),
        },
        {
          name: 'Anagrafica voucher',
          path: 'voucher/angraficaVoucher',
          meta: { requiresAuth: true },
          component: () => import('@/app/voucher/listVoucher'),
        },
        {
          name: 'Riscatto voucher',
          path: 'voucher/redeemVoucher',
          meta: { requiresAuth: true },
          component: () => import('@/app/voucher/redeemQR'),
        },
        {
          name: 'Gestione voucher',
          path: 'voucher/gestVoucher/:voucherCode?',
          meta: { requiresAuth: true },
          component: () => import('@/app/voucher/gestVoucher'),
          props: (route) => ({ voucherCode: route.params.voucherCode }),
        },
        {
          name: 'Anagrafica tessere',
          path: 'tesserati/anagraficaTessere',
          meta: { requiresAuth: true },
          component: () => import('@/app/tessere/listTessere'),
        },
        {
          name: 'Radiazione soci',
          path: 'tesserati/radiazioneSoci',
          meta: { requiresAuth: true },
          component: () => import('@/app/tessere/radiazioneSoci'),
        },
        {
          name: 'Tesseramento',
          path: 'tesserati/tesseramento/:masterId?',
          meta: { requiresAuth: true },
          component: () => import('@/app/tessere/tesseramento'),
          props: (route) => ({ masterId: route.params.masterId })
        },
        {
          name: 'Tesseramento Massivo',
          path: 'tesserati/tesseramentoMassivo',
          meta: { requiresAuth: true },
          component: () => import('@/app/tessere/tesseramentoMassivo'),
        },
        {
          name: 'Certificati attivi',
          path: 'documenti/certificati/attivi',
          meta: { requiresAuth: true },
          component: () => import('@/widget/listCertificati'),
          props: (route) => ({ masterId: route.params.masterId, mode: "active" })
        },
        {
          name: 'Generazione verbali assemblea',
          path: 'contab/verbali',
          meta: { requiresAuth: true },
          component: () => import('@/app/contab/verbali'),
        },
        {
          name: 'Anagrafica località',
          path: 'eventi/anagraficaLocation',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/listLocation'),
        },
        {
          name: 'Gestione località',
          path: 'eventi/gestLocation/:method/:locId?',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/gestLocation'),
          props: (route) => ({ method: route.params.method, locId: route.params.locId }),
        },
        {
          name: 'Lista eventi',
          path: 'eventi/listEventi',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/listEventi'),
        },
        {
          name: 'Lista gare',
          path: 'eventi/listGare',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/listGare'),
        },
        {
          name: 'Riepilogo gara',
          path: 'eventi/riepilogoGara/:idGara',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/riepilogoGara'),
          props: (route) => ({ idGara: route.params.idGara }),
        },
        {
          name: 'Gestione routine di gara',
          path: 'eventi/editGaraDettaglio/:idGara',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/gestGaraDettaglio'),
          props: (route) => ({ idGara: route.params.idGara }),
        }, {
          name: 'Gestione partecipanti routine',
          path: 'eventi/editGaraPartecipanti/:idGara/:idGareDettaglio',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/gestGaraPartecipanti'),
          props: (route) => ({ idGara: route.params.idGara, idGareDettaglio: route.params.idGareDettaglio }),
        },
        {
          name: 'inserimento punteggi gara',
          path: 'eventi/insertPuntiGara/:idEvento?/:idPacchetto?',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/insertPuntiGara'),
          props: (route) => ({ idEvento: route.params.idEvento, idPacchetto: route.params.idPacchetto }),
        },
        {
          name: 'Gestione evento',
          path: 'eventi/gestEvento/:method/:idEvento?',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/gestEvento'),
          props: (route) => ({ method: route.params.method, idEvento: route.params.idEvento }),
        },
        {
          name: 'Iscrizione evento',
          path: 'eventi/iscrizioneEvento/:idEvento/:masterId?',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/iscrizioneEvento'),
          props: (route) => ({ paramsMasterId: route.params.masterId ? parseInt(route.params.masterId) : null, paramsIdEvento: route.params.idEvento ? parseInt(route.params.idEvento) : null }),
        },
        {
          name: 'Upgrade evento',
          path: 'eventi/massiveUpgradeEvento/:idEvento',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/massiveUpgradeEvento'),
          props: (route) => ({ idEvento: route.params.idEvento }),
        },
        {
          name: 'Iscritti evento',
          path: 'eventi/iscrittiEvento/:idEvento',
          meta: { requiresAuth: true },
          component: () => import('@/app/eventi/iscrittiEvento'),
          props: (route) => ({ idEvento: route.params.idEvento }),
        },
        {
          name: 'lista prodotti',
          path: 'prodotti/listProducts',
          meta: { requiresAuth: true },
          component: () => import('@/app/prodotti/listProducts')
        },
        {
          name: 'gestione prodotti',
          path: 'prodotti/gestProduct/:method/:idProduct?',
          meta: { requiresAuth: true },
          props: (route) => ({ method: route.params.method, idProduct: route.params.idProduct }),
          component: () => import('@/app/prodotti/gestProduct')
        },
        {
          name: 'acquisto prodotto',
          path: 'prodotti/buyProduct/:idProduct?',
          meta: { requiresAuth: true },
          props: (route) => ({ idProduct: parseInt(route.params.idProduct) }),
          component: () => import('@/app/prodotti/buyProduct')
        },
        {
          name: 'movimenti contabili',
          path: 'contab/listMovimenti/:type?',
          meta: { requiresAuth: true },
          component: () => import('@/app/contab/listMovimenti'),
          props: (route) => ({ type: route.params.type })
        },
        {
          name: 'causali contabili',
          path: 'contab/listCausali',
          meta: { requiresAuth: true },
          component: () => import('@/app/contab/listCausali'),
        },
        {
          name: 'gestione movimento contabile',
          path: 'contab/gestMovimento/:method/:annoCge?/:numeCge?',
          meta: { requiresAuth: true },
          component: () => import('@/app/contab/gestMovimento'),
          props: (route) => ({ method: route.params.method, annoCge: route.params.annoCge, numeCge: route.params.numeCge })
        },
        {
          name: 'gestione causale contabile',
          path: 'contab/gestCausale/:method/:cauId?',
          meta: { requiresAuth: true },
          component: () => import('@/app/contab/gestCausale'),
          props: (route) => ({ method: route.params.method, cauId: route.params.cauId })
        },
        {
          name: 'dashboard contabile',
          path: 'contab/dashboard',
          meta: { requiresAuth: true },
          component: () => import('@/app/contab/dashboard'),
        },
        // pannello amministrativo contabile
        {
          name: 'contab settings',
          path: 'contab/adminPanel',
          meta: { requiresAuth: true },
          component: () => import('@/app/contab/adminPanel'),
        },

        {
          name: 'Scarica cassa utente',
          path: 'contab/scaricaCassaUtente/:masterId/:importo',
          meta: { requiresAuth: true },
          component: () => import('@/app/contab/gestMovimento'),
          props: (route) => ({ method: "GIROCONTO", masterId: route.params.masterId, importo: route.params.importo }),
        },
        // pannello amministrativo ente
        {
          name: 'pannello ente',
          path: 'ente/entePanel',
          meta: { requiresAuth: true },
          component: () => import('@/app/ente/entePanel'),
        },
        // pannello amministrativo associazione
        {
          name: 'pannello associazione',
          path: 'ente/associazionePanel',
          meta: { requiresAuth: true },
          component: () => import('@/app/ente/associazionePanel'),
        },
        {
          name: 'approvazione modifiche',
          path: 'ente/approveModify/:asdCode',
          meta: { requiresAuth: true },
          component: () => import('@/app/ente/approveModify'),
          props: (route) => ({ asdCode: route.params.asdCode }),
        },
        // acquisto tesssere affiliazione
        {
          name: 'acquisto tessere ente',
          path: 'ente/buyEnteTessere/:asdCode',
          meta: { requiresAuth: true },
          props: (route) => ({ asdCode: route.params.asdCode }),
          component: () => import('@/app/ente/buyEnteTessere')
        },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404',
          path: '',
          props: { errorId: '404', errorMsg: 'The requested page was not found' },
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
}
let mgmt_routers = {
  mode: 'hash',
  /*mode: 'history',*/
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: "/mgmt/console",
      props: {
        fullscreen: true,
        theme: 'light',
      },
    },
    {
      path: '/mgmt',
      redirect: { path: '/mgmt/console' },
      meta: { requiresMgmtAuth: true },
      props: { menu: false },
      component: () => import('@/views/pages/Mgmt'),
      children: [
        {
          name: 'Management Console',
          path: 'console',
          props: (route) => ({ overflow: false }),
          component: () => import('@/app/mgmt/console'),
        }, {
          name: 'Firewall',
          path: 'firewall',
          props: (route) => ({ overflow: false }),
          component: () => import('@/app/mgmt/firewall'),
        }, {
          name: 'Gestione traduzioni',
          path: 'translations',
          props: (route) => ({ overflow: false }),
          component: () => import('@/app/mgmt/translations'),
        },
        {
          path: 'login',
          name: 'Management Login',
          props: (route) => ({ overflow: false }),
          component: () => import('@/app/mgmt/login'),
        },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404',
          path: '',
          props: { errorId: '404', errorMsg: 'The requested page was not found' },
          component: () => import('@/views/pages/Error'),
        },
      ],
    }]
};

if (portal_mode && portal_mode.active && portal_mode.mode === "mgmt") {
  router = new Router(mgmt_routers);
}
else if (portal_mode && portal_mode.error) {
  router = new Router(error_routers);
}
else {
  router = new Router(portal_routers);
}

router.beforeEach((to, from, next) => {
  next();
  // if (from.path === '/') next({ path: '/portal' })
  // else next()
});

export default router